import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PhoneNumberInput from './PhoneNumberInput';
import VerificationCodeInput from './VerificationCodeInput';
import CheckmarkIcon from '../../../assets/CheckmarkIcon';
import { track } from '../../../utils/analytics';
import { connect } from 'react-redux';
import * as actions from '../../../state/actions/phoneVerification';
const phone = require('phone');

class VerifyPhone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      code: '',
      sending: false,
      phoneNumber: '',
      validNumberInProps: false,
    };
  }

  static propTypes = {
    userId: PropTypes.string.isRequired,
    handleValidated: PropTypes.func.isRequired,
    phoneNumber: PropTypes.string,
    className: PropTypes.string,
    buttonClassName: PropTypes.string,
    optionsContainerClassName: PropTypes.string,
  };

  static defaultProps = {
    className: '',
    buttonClassName: '',
    optionsContainerClassName: '',
    phoneNumber: null,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.sms.sent) {
      this.setState({ sending: false });
    }
    // eslint-disable-next-line
    if (nextProps.sms.valid == true) {
      this.props.handleValidated(this.number());
    }
  }

  componentDidMount() {
    if (this.isPhoneNumberValid(this.props.phoneNumber)) {
      this.setState({ phoneNumber: this.props.phoneNumber, validNumberInProps: true });
    }
  }

  number = () => (this.state.validNumberInProps ? this.props.phoneNumber : this.state.phoneNumber);

  send = () => {
    if (!this.isPhoneNumberValid()) return;
    this.setState({ error: null, sending: true });
    track('DASHBOARD_SETTINGS_PHONE_CODE_SENT');
    this.props.sendSms(this.number());
  };

  verify = code => {
    if (this.isCodeValid(code) === false) return;
    const {
      // state: { validNumberInProps },
      props: { userId, checkSms },
      number,
    } = this;
    this.setState({ checking: true });
    checkSms({
      phoneNumber: number(),
      code,
      userId,
    });
  };

  isPhoneNumberValid = (num = this.number()) => {
    const validatedPhone = phone(num, 'USA');
    if (validatedPhone.length) {
      track('DASHBOARD_SETTINGS_PHONE_NUMBER_VALID');
      return true;
    } else {
      this.setState({ error: 'Valid US phone number required' });
      track('DASHBOARD_SETTINGS_PHONE_ERROR_NUMBER_INVALID');
      return false;
    }
  };

  isCodeValid = (code = this.state.code) => {
    if (code === '' || code.length !== 5) {
      this.setState({
        error: 'Please enter the five-digit verification code',
      });
      track('DASHBOARD_SETTINGS_PHONE_ERROR_INVALID_CODE');
      return false;
    } else {
      this.setState({ error: null });
      track('DASHBOARD_SETTINGS_PHONE_CODE_VALID_SUCCESS');
      return true;
    }
  };

  reset = () => {
    this.setState({ error: null, phoneNumber: '', validNumberInProps: false });
    track('DASHBOARD_SETTINGS_PHONE_RESET');
    this.props.reset();
  };

  resend = () => {
    this.props.sendSms(this.number());
    track('DASHBOARD_SETTINGS_PHONE_CODE_RESENT');
    this.setState({ resent: true });
  };

  renderError = message => <div style={{ color: 'red' }}>{message}</div>;

  renderLoader = () => (
    <div
      className="loader"
      style={{
        height: 60,
        width: 60,
        margin: '-30px auto 10px',
      }}
    />
  );

  renderSendCode = () => {
    const {
      send,
      isPhoneNumberValid,
      renderError,
      renderLoader,
      state: { error, sending, phoneNumber, validNumberInProps },
    } = this;
    const { sendError } = this.props;
    track('DASHBOARD_SETTINGS_PHONE_SEND_CODE_SCREEN_LOADED');
    return (
      <div className={`${this.props.className}`}>
        <PhoneNumberInput
          fontSize={3} // TODO: Allow smaller font size on mobile
          onChange={newValue => {
            this.setState({ phoneNumber: newValue });
            if (newValue.length === 10) {
              isPhoneNumberValid(newValue);
            }
          }}
          value={phoneNumber}
          disabled={validNumberInProps}
          autofocus
        />
        <div className={`${this.props.optionsContainerClassName} text-center`}>
          {error && renderError(error)}
          {sendError && renderError(sendError)}
          <input
            type="button"
            name="button"
            value="Send Code"
            disabled={sending}
            className={`${this.props.buttonClassName}`}
            style={{
              backgroundColor: sending ? 'gray' : '#26E3BA',
            }}
            onClick={send}
          />
          {sending && renderLoader()}
        </div>
      </div>
    );
  };

  renderCheckCode = () => {
    const {
      verify,
      resend,
      reset,
      number,
      renderError,
      renderLoader,
      state: { error, checking, resent, code },
    } = this;
    const { sendError, checkError } = this.props.sms;
    const pn = number().toString();
    const contactUrl = `${process.env.REACT_APP_DOMAIN}/contact`;

    track('DASHBOARD_SETTINGS_PHONE_ENTER_CODE_SCREEN_LOADED');

    return (
      <div className={`${this.props.className}`}>
        <p style={{ maxWidth: 275, margin: '0 auto' }}>
          Please enter the 5 digit code sent to your number{' '}
          <span style={{ color: '#0de0aa' }} className="pb-10">
            +x xxx xxx-{pn.slice(pn.length - 4, pn.length)}
          </span>
        </p>
        <VerificationCodeInput
          fontSize={8}
          onChange={newValue => {
            if (code.length === 4 && newValue.length === 5) {
              verify(newValue);
            }
            this.setState({ code: newValue });
          }}
          autofocus
          disabled={checking}
          style={{ textAlign: 'center', marginTop: 25 }}
        />
        <div className={`${this.props.optionsContainerClassName} text-center`}>
          {error && renderError(error)}
          {checkError && renderError(error)}
          <input
            type="button"
            name="button"
            value="Submit"
            disabled={checking}
            className={`${this.props.buttonClassName}`}
            style={{
              backgroundColor: checking ? 'gray' : '#26E3BA',
            }}
            onClick={verify}
          />
          {checking && renderLoader()}
          <div className="textContainer">
            {sendError ? (
              <div>
                <span>Error re-sending code. Please </span>
                <a href={contactUrl} style={{ color: '#28EBC1' }}>
                  contact us
                </a>
                .
              </div>
            ) : resent ? (
              <div>
                <CheckmarkIcon style={{ display: 'inline', marginRight: 10 }} />
                <span>SMS resent</span>
              </div>
            ) : (
              <div>
                <span>Didn’t receive our SMS confirmation code?</span>
                <span style={{ color: '#0DE0AA' }} onClick={resend}>
                  {' '}
                  Re-send SMS
                </span>
              </div>
            )}
          </div>
          <div>
            <span>Use a </span>
            <input
              type="button"
              name="button"
              onClick={reset}
              value="different phone number"
              style={{
                color: '#0DE0AA',
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  renderSuccess = () => {
    track('DASHBOARD_SETTINGS_PHONE_SUCCESS_SCREEN_LOADED');
    return <div className={`${this.props.className}`}>Success! Grats.</div>;
  };

  render() {
    const {
      renderSendCode,
      renderCheckCode,
      renderSuccess,
      props: {
        sms: { sent, valid },
      },
    } = this;

    return valid ? renderSuccess() : sent ? renderCheckCode() : renderSendCode();
  }
}

export default connect(
  state => ({
    sms: { ...state.phoneVerification },
  }),
  actions,
)(VerifyPhone);
